module.exports = __webpack_public_path__ + "img/sepid5_1.6a9df63c.webp";